export default function ReputationSection() {
  const reputations = [
    {
      name: "张明远",
      title: "知名科技博主 / 百万粉丝创作者",
      quote: "海角千万是我日常创作最重要的资源库。无论是配图素材还是视频空镜，质量都非常高，而且完全不用担心版权问题。极大地提升了我的创作效率。",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20casual%20business%20attire%2C%20warm%20studio%20lighting%2C%20neutral%20cream%20background%2C%20friendly%20approachable%20expression%2C%20high%20quality%20editorial%20photography&width=200&height=200&seq=avatar-zmy&orientation=squarish"
    },
    {
      name: "李思涵",
      title: "独立设计师 / 设计工作室创始人",
      quote: "作为一个独立设计师，海角千万的设计模板库帮我节省了大量时间。模板质量很高，版权清晰，可以放心用于商业项目，是我工作室不可或缺的工具。",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20with%20shoulder%20length%20hair%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20confident%20smile%2C%20creative%20professional%20look%2C%20editorial%20photography&width=200&height=200&seq=avatar-lsh&orientation=squarish"
    },
    {
      name: "王浩然",
      title: "品牌营销总监 / 上市企业市场部",
      quote: "选择海角千万作为企业资源合作伙伴是一个非常明智的决定。丰富的素材库加上完善的版权保障，让我们的品牌传播团队可以心无旁骛地专注于创意本身。",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20smart%20casual%20blazer%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20confident%20professional%20expression%2C%20editorial%20photography&width=200&height=200&seq=avatar-whr&orientation=squarish"
    },
    {
      name: "陈雨萱",
      title: "自媒体运营达人 / 全网500万粉丝",
      quote: "作为每天需要产出大量内容的创作者，海角千万的更新速度让我非常惊喜。天天都有新素材，风格多样，总能找到契合我内容调性的资源。真心推荐给每一位创作者！",
      avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20with%20long%20hair%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20bright%20genuine%20smile%2C%20creative%20casual%20style%2C%20editorial%20photography&width=200&height=200&seq=avatar-cyx&orientation=squarish"
    },
  ];

  return (
    <div>
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-2">用户口碑</h2>
        <p className="text-foreground-600 text-sm">听听创作者们怎么说</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reputations.map((item, i) => (
          <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={item.avatar}
                alt={item.name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <div className="font-medium text-foreground-900 text-sm">{item.name}</div>
                <div className="text-foreground-500 text-xs">{item.title}</div>
              </div>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">"{item.quote}"</p>
          </div>
        ))}
      </div>
    </div>
  );
}